(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptFileDeleteController',ReceiptFileDeleteController);

    ReceiptFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReceiptFile'];

    function ReceiptFileDeleteController($uibModalInstance, entity, ReceiptFile) {
        var vm = this;

        vm.receiptFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReceiptFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
